import { BookingService } from '../Booking/Service';

// Explicit report columns keep operational secrets out of downloaded files.
export const bookingServiceHeaders = [
  'Service details', 'Service date', 'Requested service', 'Service ID', 'Brand', 'SAC', 'Quantity',
  'Time slot start', 'Time slot end', 'Price (INR)', 'Service total (INR)',
  'Booking subtotal (INR)', 'Platform fee (INR)', 'Convenience fee (INR)', 'Discount (INR)',
  'Coins used (INR)', 'Coupon applied (INR)', 'Visiting charges (INR)', 'Taxes (INR)', 'Booking total (INR)',
  'Customer ID', 'Customer name', 'Customer contact', 'Customer address', 'Customer landmark',
  'Service contact name', 'Service contact mobile', 'Service address', 'Landmark', 'City', 'State', 'Pincode',
  'Expert ID', 'Expert name', 'Expert custom name', 'Expert business name', 'Expert contact', 'Expert waived visit charge (INR)',
];

const value = (input) => input ?? 'Unavailable';

export async function bookingServiceRows(bookings, baseRows, isCurrent) {
  const rows = [];
  for (let index = 0; index < bookings.length; index += 1) {
    if (!isCurrent()) return null;
    const booking = bookings[index];
    if (booking.recordType === 'quick_book_request') {
      rows.push([...baseRows[index], 'Unassigned Quick Book request', ...Array(bookingServiceHeaders.length - 1).fill('Unavailable')]);
      continue;
    }
    const response = await BookingService.bookingDetailById(booking.id);
    if (!isCurrent()) return null;
    const detail = response?.data;
    if (response?.success !== 1 || !detail || !Array.isArray(detail.bookingItems)) {
      throw new Error('Could not load all booking service details. Please try again.');
    }
    const common = [
      detail.subTotal, detail.platformCharges, detail.convenienceFee, detail.discount, detail.coinValue,
      detail.couponAmount, detail.visitingCharge, detail.tax, detail.total,
      detail.customerId, detail.customerName, detail.customer?.mobileNumber, detail.add_address, detail.add_landmark,
      detail.add_customerFullName, detail.add_mobileNumber, detail.add_address, detail.add_landmark,
      detail.add_city, detail.add_state, detail.add_pincode,
      detail.providerId, detail.providerName, detail.customName, detail.businessName, detail.provider?.mobileNumber,
      detail.provider?.UserProfile?.waiveVisitCharge,
    ].map(value);
    // Keep bookings without services in the report as well.
    for (const item of detail.bookingItems.length ? detail.bookingItems : [null]) {
      const price = item?.price;
      const quantity = item?.quantity;
      const total = price != null && quantity != null && Number.isFinite(Number(price)) && Number.isFinite(Number(quantity))
        ? (Number(price) * Number(quantity)).toFixed(2) : 'Unavailable';
      rows.push([...baseRows[index], item ? 'Available' : 'No requested services', value(detail.serviceDate),
        value(item?.serviceName), value(item?.providerServices?.servicesChildId ?? item?.quickBookServiceId),
        item?.providerServices?.brd?.id === 1 || item?.providerServices?.brd?.id === '1' ? '' : value(item?.providerServices?.brd?.title),
        value(item?.providerServices?.childService?.gstDetails?.sac), value(quantity),
        value(detail.bookingStartTime), value(detail.bookingEndTime), value(price), total, ...common]);
    }
  }
  return rows;
}
